import { render, staticRenderFns } from "./stock-rose.vue?vue&type=template&id=89433144&"
import script from "./stock-rose.vue?vue&type=script&lang=js&"
export * from "./stock-rose.vue?vue&type=script&lang=js&"
import style0 from "./stock-rose.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports